import { h, Fragment } from "preact";
import { useState, useEffect, useContext, } from "preact/hooks";
import { Box, Button, Grid, Paper, Stack, Tooltip, Typography } from "@mui/material";



import EventsTimeLineCard from "../Common/EventsTimeLineCard";
import PersonnalCard from "../Common/PersonnalCard";
import MentoringCard from "../Common/MentoringCard";
import AmbassadorDealsCard from "../Common/AmbassadorDealsCard";


import { AppContext } from "../../AppContext";
import { SessionContext } from "../../SessionContext";

import { redThreadUser } from "../Common/redthread";

export default function DashboardAmbassador(props) {
	//
	//console.log("DashboardAmbassador", props);
	const [state, setState] = useState({ ctx: undefined });
	const app = useContext(AppContext);

	const [session, setSession] = useContext(SessionContext);
	useEffect(() => {

		if (!session.u) { return }
		let topic = "room:uda-" + session.u
		if (session.socket && state.ctx && session[topic] === undefined) {
			//console.log("session context connecting")
			let channel = session.socket.channel(topic, {})

			channel.on("new_msg",
				msg => {
					if (msg.r) {
						window.location.reload();
					}


				})

			channel.join()
				.receive("ok", ({ messages }) => {
					//console.log("catching up for ", messages, "room:ud-" + state.ctx.uid)
					setSession({ ...session, [topic]: channel })
				})
				.receive("error", ({ reason }) => console.log("failed join", reason))
				.receive("timeout", () => console.log("Networking issue. Still waiting..."))

		}
	}, [session, state]);
	useEffect(() => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/efc8bbe9865a414296ca7b6d0c928d22", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setState((state) => ({
							...state,
							ctx: res.pld,
						}));
						//console.log(props.matches)
						if (props.matches && props.matches.new_case === "1") {
							app.refPopUp.current.handleChangeState(
								{ opened: true, type: "004" })
						}

						break;
					case "err":
						break;
					default:
						break;
				}
			});
	}, []);

	useEffect(() => {

		redThreadUser(state, app, "ambassadeur");


	}, [state]);
	const goToDeal = (u) => {
		window.location.href = "/7bac6cb9d6ee4d70b1315393725f3a34/" + u;
	};

	if (state.ctx === undefined) {
		return false;
	}

	return (


		<Grid container spacing={2}>
			<Grid item xs={12}>
				<Paper style="padding: 10px;">
					<Grid container alignItems="center">
						<Grid item xs={6}>
							<Typography variant="h5"  >Bienvenue dans votre espace ambassadeur</Typography>
						</Grid>
						<Grid item xs>
							<Box display="flex" justifyContent="flex-end" alignItems="center" flexDirection="row">


								{false && (
									<Box>
										<Tooltip
											title="Si vous avez été invité par un vendeur, vous avez reçu un code à indiquer en cliquant ici"
											placement="bottom"
											arrow
											style="margin-left: 10px;"
										>
											<Button
												variant="outlined"
												onClick={
													() => {
														state.ctx.user_undone.length == 0
															? app.refPopUp.current.handleChangeState(
																{ opened: true, type: "006" }
															)
															: app.refPopUp.current.handleChangeState(
																{ opened: true, type: "005" }
															)
													}}
											>
												Rejoindre un dossier de vente
											</Button>
										</Tooltip>
									</Box>
								)}
							</Box>
						</Grid>
					</Grid>
				</Paper>
			</Grid >
			<Grid item xs={12} md={6}>

				<Stack spacing={1}>
					<PersonnalCard user={state.ctx} role="AM" />
					<AmbassadorDealsCard ctx={state.ctx} />
				</Stack>
			</Grid>
			<Grid item xs={12} md={6}>
				<Stack spacing={1}>
					{state.ctx && (
						<MentoringCard state={state} id={props.id} />
					)}

					<EventsTimeLineCard events={state.ctx.events} />
				</Stack>
			</Grid>
		</Grid >

	);
}


